import React, { Component } from 'react';
import classnames from 'classnames';
import styles from './Tabs.scss';
import lodash from 'lodash';
import {Tab} from 'components/common/Tab/Tab';

export class Tabs extends Component {
    
    getActiveTab() {
        const { tabs: tabsToCheck, location: { pathname } } = this.props;
        let currentPathLength = -1;
        let activeTab = null;
        for (let tab of tabsToCheck) {
            const isBetterMatch = lodash.startsWith(pathname, tab.path) && tab.path.length > currentPathLength;

            if (isBetterMatch) {
                currentPathLength = tab.path.length;
                activeTab = tab;
            }
            activeTab = this.getBinderTaskActiveTab(tab, pathname, activeTab);
        }
        return activeTab;
    }
    
    getBinderTaskActiveTab(tab, pathname, activeTab) {
        if(lodash.includes(tab.path, 'pending') && this.getSubPath(pathname) == ''){
            activeTab = tab;
        }
        return activeTab;
    }

    getSubPath(location) {
        return lodash.last(location.split('/'));
    }

    render() {
        const tabElement = this.props.tabs.map(tab => {
            const activeTab = this.getActiveTab();
            const isActiveTab = activeTab ? tab.path === activeTab.path : false;
            return(
                <Tab 
                    key={tab.path} 
                    path={tab.path} 
                    label={tab.label} 
                    isActiveTab =  {isActiveTab}
                    backgroundHighlight = {tab.backgroundHighlight}
                    data-cy="Tabs-return"
                />
            );
        });

        return(
            <nav  className={classnames(this.props.className, styles.tabs)} data-cy="Tabs-nav">
                { tabElement }
            </nav>
        );
    }
}
